import { Suspense, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { ROUTES } from "@/constants";
import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";
import { RootState } from "@/store";

import { PrivateLayout } from "./layout/PrivateLayout";
import { RoleGuard } from "./layout/RoleGuard";
import { routes } from "./routes";

export const Pages = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const versionChanged = useAppSelector(
        (state: RootState) => state._versionChanged, // err
    );
    const [hasRedirected, setHasRedirected] = useState(false);

    useEffect(() => {
        if (versionChanged && !hasRedirected) {
            setHasRedirected(true);
            navigate(ROUTES.WorkPlan);
        }
    }, [versionChanged, hasRedirected, navigate, location]);

    const publicRoutes = routes.filter((route) => !route.isPrivate);
    const privateRoutes = routes.filter((route) => route.isPrivate);

    return (
        <Suspense fallback={<div>Завантаження...</div>}>
            <Routes>
                {publicRoutes.map(({ path, component: Component }) => (
                    <Route key={path} path={path} element={<Component />} />
                ))}

                <Route element={<PrivateLayout />}>
                    {privateRoutes.map(
                        ({ path, component: Component, allowedRoles }) => (
                            <Route
                                key={path}
                                element={
                                    <RoleGuard allowedRoles={allowedRoles} />
                                }
                            >
                                <Route path={path} element={<Component />} />
                            </Route>
                        ),
                    )}
                </Route>

                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    );
};
